import { ReactFlowInstance, Node, Edge } from "@xyflow/react";
import {RJSFSchema} from "@rjsf/utils";

/**
 * Delete workflow node and all child nodes and edges
 * @param context
 * @param reactFlowInstance
 */
export function processNodeDelete(context: any, reactFlowInstance: ReactFlowInstance): void {
    let nodes: Node[] = context.nodes;
    let newNodes: Node[] = [];
    for (const node of nodes) {
        if (!node.id.includes(context.activeExtractionNode.id)) {
            newNodes.push(node);
        }
    }

    let edges: Edge[] = context.edges;
    let newEdges: any[] = [];
    for (const edge of edges) {
        if (!edge.id.includes(context.activeExtractionNode.id)) {
            newEdges.push(edge);
        }
    }

    context.updateLayoutNodes(newNodes);
    context.updateLayoutEdges(newEdges);
}


export function processNodeFormSubmit(context: any, formData: any, reactFlowInstance: ReactFlowInstance): void {
    // debugger;
    let editNode: Node = context.activeExtractionNode;
    if (editNode === undefined) {
        return;
    }
    editNode.data = formData;

    let allNodes: Node[] = reactFlowInstance.getNodes();
    let newNodes: Node[] = [];
    let activeIds: any[] = [];
    for (const node of allNodes) {
        if (!activeIds.includes(node.id)) {
            activeIds.push(node.id);
            newNodes.push(node);
        }
    }

    let updatedNodes = [editNode];
    for (const node of newNodes) {
        if (node.id !== editNode.id) {
            updatedNodes.push(node);
        }
    }
    ;
    reactFlowInstance.updateNodeData(editNode.id, formData);
    context.updateLayoutNodes(updatedNodes);

}

export const formSchema: RJSFSchema = {
    title: '',
    type: 'object',
    required: [],
    properties: {
        'extraction_data_type': {
            title: 'Extraction Data Type',
            type: 'string',
            enum: [
                'Text',
                'Number',
                'Array',
                'Key/Value Array',
                'True/False',
                'Data Model'
            ],
            default: 'Text',
            description: 'Type of data to create with the extracted data'
        },
        extractions: {
            title: 'Extractions',
            type: 'array',
            items: {
                title: '',
                type: 'object',
                properties: {
                    'data_input': {
                        title: 'Data Input',
                        type: 'string',
                        description: 'Location of data',
                        default: 'default'
                    },
                    input_key: {
                        title: 'Input Key',
                        type: 'string',
                        description: 'Key of data to extract if applicable. Use value_one/value_two for nested data or __END__ for last key',
                    },

                }
            }
        },
        'data_management': {
            title: 'Data Store',
            type: 'string',
            description: 'Location to store results',
            default: 'default'
        },
        add_output_to_message: {
            title: 'Add Output To Messages',
            type: 'boolean',
            default: false,
            description: 'Store output as a message to keep in the message history as well as Data store',
        },
    },
    allOf: [
        {
            if: {
                properties: {
                    extraction_data_type: {
                        oneOf: [
                            {
                                const: 'Text'
                            },
                            {
                                const: 'Number'
                            },
                            {
                                const: 'True/False'
                            }
                        ]
                    }
                }
            },
            then: {
                properties: {
                    extractions: {
                        maxItems: 1
                    }
                }
            }
        },
        {
            if: {
                properties: {
                    extraction_data_type: {
                        const: 'Key/Value Array'
                    }
                }
            },
            then: {
                properties: {
                    custom_key_value_array_schema: {
                        type: 'string',
                        title: 'JSON schema for key/value object'
                    },
                    extractions: {
                        items: {
                            properties: {
                                key_value_key: {
                                    title: 'Location to add extracted value',
                                    type: 'string',
                                    description: 'Use value_one/value_two for nested data',
                                }
                            }

                        }
                    }
                },
            }
        },
        {
            if: {
                properties: {
                    extraction_data_type: {
                        const: 'Data Model'
                    }
                }
            },
            then: {
                properties: {
                    custom_data_model_schema: {
                        type: 'string',
                        title: 'JSON schema for Data Model'
                    },
                    extractions: {
                        items: {
                            properties: {
                                key_value_key: {
                                    title: 'Location to add extracted value',
                                    type: 'string',
                                    description: 'Use value_one/value_two for nested data',
                                }
                            }

                        }
                    }
                }
            }
        },
        {
            if: {
                properties: {
                    data_management: {
                        const: 'messages'
                    }
                }
            },
            then: {
                properties: {
                    add_output_to_message: {
                        readOnly: true,
                    }
                }
            }
        }
    ]
}

export const nodeDescription: string = "This node is used to extract a value from a Data Model or key/value array.\n" +
    "If the extracted value exists, it will be added to the Data Store slot for the next node.";

